export default __webpack_public_path__ + "fd58161725edd92a2a8a125e14f792ba.png";